<template>
  <div
    class="Fuell-CreditCard"
    :class="{
      'Fuell-CreditCard--physical': isCardPhysical,
      'Fuell-CreditCard--disabled': isCardDisabled,
      'Fuell-CreditCard--active': active
    }"
    @click="showCardDetailModal"
  >
    <button
      class="Fuell-CreditCard--actions-button Fuell-Dropdown--button-dots"
      @click="showCardDetailModal"
      v-if="!active"
    >
      <img
        alt="dot-icon-menu"
        :src="require('@/assets/img/icons/icon-dots.svg')"
      />
    </button>
    <div class="Fuell-CreditCard--badge">
      <user-name-badge
        :userName="cardAlias"
        :userAvatarId="customCardLogo"
        :classList="'Thumb--40'"
        v-if="cardType !== 'MEMBER_PHYSICAL'"
      ></user-name-badge>
      <user-name-badge
        :userName="cardUserOwnerFullName"
        :userAvatarId="cardUserProfilePicture"
        :classList="'Thumb--40'"
        v-else
      ></user-name-badge>
    </div>
    <div class="Fuell-CreditCard--block">
      <div
        class="Fuell-CreditCard--alias"
        v-if="cardType !== 'MEMBER_PHYSICAL'"
        v-tooltip="cardAlias"
      >
        <v-clamp :max-lines="2">
          {{ cardAlias }}
        </v-clamp>
      </div>
      <div
        class="Fuell-CreditCard--alias"
        v-if="cardType === 'MEMBER_PHYSICAL'"
        v-tooltip="cardUserOwnerFullName"
      >
        <v-clamp :max-lines="2">
          {{ cardUserOwnerFullName }}
        </v-clamp>
      </div>
      <div
        class="Fuell-CreditCard--type"
        v-if="cardType !== 'MEMBER_PHYSICAL'"
        v-tooltip="cardAssignedBudgetName"
      >
        <v-clamp :max-lines="2">
          {{ cardAssignedBudgetName }}
        </v-clamp>
      </div>
      <div
        class="Fuell-CreditCard--type ellipsis"
        v-if="cardType === 'MEMBER_PHYSICAL'"
      >
        {{ $t('transactions_card_type__MEMBER_PHYSICAL') }}
      </div>
    </div>
    <div class="Fuell-CreditCard--info">
      <div class="Fuell-CreditCard--block">
        <div
          class="d-flex"
          v-if="cardType !== 'MEMBER_PHYSICAL'"
        >
          <div v-if="!isUser">
            <user-name-badge
              thumbSizeClass="Thumb--24"
              :userName="cardUserOwnerFullName"
              :userAvatarId="cardUserProfilePicture"
            ></user-name-badge>
          </div>
          <div
            class="ellipsis"
            v-tooltip="cardUserOwnerFullName"
          >
            {{ cardUserOwnerFullName }}
          </div>
        </div>
      </div>
      <div
        class="Fuell-CreditCard--block mt-2"
        v-if="cardPartialPan"
      >
        <div class="d-flex align-items-center">
          <div v-if="cardPartialPan">
            <div class="Thumb Thumb--24 mr-2">
              <img
                :src="require('@/assets/img/mc-provider.png')"
                alt="provider"
              />
            </div>
          </div>
          <div v-if="cardPartialPan">·· {{ cardPartialPan }}</div>
        </div>
      </div>
      <div
        class="Fuell-CreditCard--not-issued"
        v-if="!card.processedByIssuer && !cardMPNumber"
      >
        {{ $t('card_not_generated') }}
      </div>
      <div
        class="Fuell-CreditCard--block Fuell-CreditCard--status"
        v-if="cardStatusActionLabelRender"
      >
        <div
          @click.stop="checkPassCode"
          :class="cardItemStatusClass"
        >
          <img
            v-if="isCardUnfreezableByAdmin && (!isAdmin && !isSuperAdmin)"
            class="card-locked-icon"
            alt="card-locked-icon"
            :src="require(`@/assets/img/icons/icon-lock-disabled.svg`)"
          />
          <span class="card-status-action-label">{{ $t(cardStatusActionLabelRender) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VClamp from 'vue-clamp'
import _cardDetailMixin from '../../_mixins/_cardDetailMixin'
import UserNameBadge from '@/components/Commons/UserNameBadge'

export default {
  name: 'Card',
  mixins: [_cardDetailMixin],
  components: { UserNameBadge, VClamp },
  props: {
    card: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showCardDetailModal () {
      this.$emit('showCardDetailModal', this.card.id)
    },
    checkPassCode () {
      if (this.isCardUnfreezableByAdmin && (!this.isAdmin && !this.isSuperAdmin)) return
      const dataForPasscodeChecking = {
        cardUserOwnerId: this.loggedUserId,
        cardStatus: this.cardStatus,
        cardId: this.card.id,
        cardInfo: this.card
      }
      this.$emit('checkPasscode', dataForPasscodeChecking)
    }
  },
  computed: {
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    loggedUserId () {
      return this.$store.getters['LoginStore/loggedUserId'] || false
    }
  }
}
</script>

<style scoped>
.Cards-itmStatus {
  z-index: 999999;
}
.card-locked-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
.card-status-action-label {
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
}
</style>
